// extracted by mini-css-extract-plugin
export default {"flex-column":"dropdown_flex-column__-qNQj","dropdown":"dropdown_dropdown__YzJZO","flex-row":"dropdown_flex-row__43FZZ","page-size":"dropdown_page-size__4Wy41"};